import { get } from 'lodash';
import en from './en';
import zh from './zh';
import zh_tw from './zh_tw';
import { getValueByLang } from '../../src/utils/comfn/util';



let locale: any = {
    en,
    zh,
    zh_tw
}

export const t = (key: string) => {
    const langConfig = getValueByLang(locale)
    try {
        let v = get(langConfig, key) || key;
        return v
    } catch (e) {
        return key;
    }
}